/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-10-12 15:02:36
 * @LastEditTime : 2023-10-13 10:52:15
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\smart\components_data\customizedReport.js
 */
import request from "@/utils/request";
/*分页获取*/
export function queryPage(data) {
  return request({
    url: "/icps/system/sign/intelligent/customReportLibrary/queryPage",
    method: "post",
    data
  });
}
/*新增*/
export function saveNewReport(data) {
  return request({
    url: "/icps/system/sign/intelligent/customReportLibrary/saveNewReport",
    method: "post",
    data
  });
}
/*删除*/
export function deleteReport(params) {
  return request({
    url: "/icps/system/sign/intelligent/customReportLibrary/deleteReport",
    method: "get",
    params
  });
}
/*获取原物料列表*/
export function queryListByCompany(params) {
  return request({
    url: "/icps/system/sign/basics/rawMaterials/queryListByCompany",
    method: "get",
    params
  });
}